import { createAction } from 'redux-actions';
export var premiumFolderPurchased = createAction('PREMIUM_FOLDER.PURCHASED', function (folderId, targetUrl) { return ({
    folderId: folderId,
    targetUrl: targetUrl
}); });
//# sourceMappingURL=actions.js.map